// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { AutomationPost } from '../../../../types/server/modules/automation/post';

export type * from '../../../../types/server/modules/automation/post';

export const createPost = ( requests: Requests ): AutomationPost => ({
  rules_draft: Object.assign(( body,headers ) => {
      return requests.post( `/rules/draft`, { body }, headers );
    }, { operation: 'automation:rules-draft', route: 'POST /rules/draft', subdomain: 'automation', visibility: 'private' } as const ),
  rules_dry_run: Object.assign(( body,headers ) => {
      return requests.post( `/rules/dry-run`, { body }, headers );
    }, { operation: 'automation:rules-dry-run', route: 'POST /rules/dry-run', subdomain: 'automation', visibility: 'private' } as const ),
  retry_rule_execution: Object.assign(( params,headers ) => {
      return requests.post( `/rule-executions/:id/retry`, params, headers );
    }, { operation: 'automation:retry-rule-execution', route: 'POST /rule-executions/:id/retry', subdomain: 'automation', visibility: 'private' } as const ),
  re_evaluate_publication_rules: Object.assign(( body,headers ) => {
      return requests.post( `/rule-executions/re-evaluate`, { body }, headers );
    }, { operation: 'automation:re-evaluate-publication-rules', route: 'POST /rule-executions/re-evaluate', subdomain: 'automation', visibility: 'private' } as const )
});
